// 토스 앱 환경 감지 — `ReactNativeWebView` 객체가 주입되어 있어야 SDK 가용
export function isInTossApp(): boolean {
  if (typeof window === 'undefined') return false;
  return !!(window as unknown as { ReactNativeWebView?: unknown }).ReactNativeWebView;
}
